module.exports = __webpack_public_path__ + "static/media/west-wind.ab8763a2.png";